import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import api, { LOGO_URL } from "@/lib/api";

const FARGORATE_LOGO = "https://customer-assets.emergentagent.com/job_pool-league-portal/artifacts/j2pezazq_fargorate-logo-horizontal-greenwhite.png";

export function Footer() {
  const [tagline, setTagline] = useState("");
  const [braggersHidden, setBraggersHidden] = useState(false);
  useEffect(() => {
    api.get("/site").then((r) => setTagline(r.data?.footer_tagline || "")).catch(() => {});
    api.get("/braggers").then((r) => setBraggersHidden(!!r.data?.hidden)).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#111111] text-white mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img src={LOGO_URL} alt="Quinte BCA Pool League" className="h-16 w-16 object-contain" />
              <span className="font-heading font-extrabold text-xl">Quinte BCA Pool League</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed" data-testid="footer-tagline">
              {tagline || "Recreational 8-ball & 9-ball league serving the Quinte region. All skill levels welcome."}
            </p>
            <div className="mt-5" data-testid="footer-fargorate">
              <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400 mb-2">Stats and Handicap powered by</p>
              <a href="https://www.fargorate.com" target="_blank" rel="noopener noreferrer" data-testid="footer-fargorate-link">
                <img src={FARGORATE_LOGO} alt="FargoRate" className="h-7 w-auto opacity-90 hover:opacity-100 transition-opacity" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-3 text-sm uppercase tracking-wider text-gray-300">Explore</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/divisions" className="hover:text-[#E23744] transition-colors">Divisions & Standings</Link></li>
              <li><Link to="/about" className="hover:text-[#E23744] transition-colors">About the League</Link></li>
              <li><Link to="/tournaments" className="hover:text-[#E23744] transition-colors">Tournaments</Link></li>
              {!braggersHidden && <li><Link to="/braggers" className="hover:text-[#E23744] transition-colors">Bragger's Cup</Link></li>}
              <li><Link to="/partners" className="hover:text-[#E23744] transition-colors">Partners</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-3 text-sm uppercase tracking-wider text-gray-300">Get in touch</h4>
            <a
              href="mailto:quintebca@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-[#E23744] transition-colors"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4" /> quintebca@gmail.com
            </a>
            <p className="mt-4 text-xs text-gray-500 flex items-center gap-3">
              <Link to="/admin/login" className="hover:text-gray-300" data-testid="footer-admin-link">League Admin</Link>
              <span className="text-gray-700">·</span>
              <Link to="/captains" className="hover:text-gray-300" data-testid="footer-captains-link">Captains Area</Link>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 text-xs text-gray-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Quinte BCA Pool League</span>
          <span>www.quintebca.ca</span>
        </div>
      </div>
    </footer>
  );
}
